import styled from 'styled-components';

import { PrimaryButton } from '../../../shared/ui';

type OnboardingCtaButtonProps = {
  label: string;
  onPress: () => void;
};

const CtaButton = styled(PrimaryButton).attrs({
  'data-ui': 'onboarding-cta-button',
})`
  align-self: center;
`;

export function OnboardingCtaButton({
  label,
  onPress,
}: OnboardingCtaButtonProps) {
  return (
    <CtaButton type="button" onClick={onPress}>
      {label}
    </CtaButton>
  );
}
